import { useState, useEffect } from 'react';
import styles from './PaymentWarningPopUp.module.css';
import PopUp from '../PopUp/PopUp';
import PaymentWarmingImage from '../../../assets/payment-warning-popup-image.webp';

const PaymentWarningPopUp = ({ isOpen, telegraUrl, onClose }) => {

  return (
    isOpen && (
        <PopUp
        maxWidth={600}
        close={onClose}
        >
            {({ closeAnimation }) => (
                <div className={styles.content}>
                    <div className={styles.imageContainer}>
                        <img src={PaymentWarmingImage} alt="Payment Warning" className={styles.image} />
                    </div>
                    <div className={styles.textContainer}>
                        <span className={styles.title}>Continue Your Online Visit</span>
                        <span className={styles.description}>
                            {telegraUrl 
                                ? 'We detected an attempt to start your online visit. You can continue where you left off.'
                                : 'We detected you may have recently completed a payment. Please verify you don\'t have an existing subscription before proceeding. If you need to check your subscription status, please contact support@tb2.health.'
                            }
                        </span>
                    </div>
                    <div className={styles.optionsContainer}>
                        {telegraUrl ? (
                            <>
                                <button 
                                onClick={() => window.location.href = telegraUrl} 
                                className={styles.proceedButton}
                                >
                                Continue Online Visit
                                </button>

                                <span 
                                onClick={closeAnimation} 
                                className={styles.proceedText}
                                >
                                Start new checkout instead
                                </span>
                            </>
                            ) : (
                            <button 
                                onClick={closeAnimation} 
                                className={styles.proceedButton}
                            >
                                I understand, proceed anyway
                            </button>
                        )}
                    </div>
                </div>
            )}
        </PopUp>
    )
  );
};

export default PaymentWarningPopUp;
